import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\AuthenticationLogController::index
* @see app/Http/Controllers/Admin/AuthenticationLogController.php:16
* @route '/admin/authentication-logs'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/authentication-logs',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AuthenticationLogController::index
* @see app/Http/Controllers/Admin/AuthenticationLogController.php:16
* @route '/admin/authentication-logs'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AuthenticationLogController::index
* @see app/Http/Controllers/Admin/AuthenticationLogController.php:16
* @route '/admin/authentication-logs'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AuthenticationLogController::index
* @see app/Http/Controllers/Admin/AuthenticationLogController.php:16
* @route '/admin/authentication-logs'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const authenticationLogs = {
    index: Object.assign(index, index),
}

export default authenticationLogs